var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLongLeftE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4548 12.5148C1.3015 12.3729 1.21436 12.1734 1.21436 11.9645C1.21436 11.7556 1.3015 11.5561 1.4548 11.4142L6.8548 6.41417C7.07354 6.21164 7.39146 6.15788 7.66463 6.27723C7.9378 6.39658 8.11436 6.66639 8.11436 6.96449V11.2145H14V10C14 8.89543 14.8954 8 16 8H20C21.1046 8 22 8.89543 22 10V14C22 15.1046 21.1046 16 20 16H16C14.8954 16 14 15.1046 14 14V12.7145H8.11436V16.9645C8.11436 17.2626 7.9378 17.5324 7.66463 17.6518C7.39146 17.7711 7.07354 17.7174 6.8548 17.5148L1.4548 12.5148Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLongLeftE);
export default __webpack_public_path__ + "static/media/arrow-long-left-e.2e7340c226f1d2bb76f3419814cabd65.svg";
export { ForwardRef as ReactComponent };